export const NB_CHAT_COMMON_FILTER = 'newbuilding_chat_common_filter';
export const NB_HELP_IN_SEARCH = 'newbuilding_consultant_help_in_search';
export const NB_CONSULTANT_TRIGGERING_MESSAGE = 'newbuilding-triggering-message';
